import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../config/api";
import { forgotMemberIdRequest, forgotMemberIdSuccess, forgotMemberIdFailure } from "../slice/forgotMemberIdSlice";
import { config } from "../../../../src/config/global";
const FORGOT_MEMBER_ID_URL = config.ROP_FORGOT_MEMBER_ID;
const forgotMemberIdData = async payload => {
  let data = {
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json"
    },
    loader: true,
    isGenericErr: true
  };
  const response = await api.post(FORGOT_MEMBER_ID_URL, payload, data);
  return response;
};
function* getForgotMemberIdData(action) {
  try {
    const {
      payload
    } = action;
    const response = yield call(forgotMemberIdData, payload);
    yield put(forgotMemberIdSuccess(response.data));
  } catch (error) {
    yield put(forgotMemberIdFailure(error?.response));
  }
}
export function* watchForgotMemberId() {
  yield takeLatest(forgotMemberIdRequest.type, getForgotMemberIdData);
}